import { Component } from '@angular/core';
import { SummarizeService } from '../summarize.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertPopup, HttpLoader } from 'app/app.config';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-summarize',
  templateUrl: './summarize.component.html',
  styleUrls: ['./summarize.component.scss'],
  standalone: false
})
export class SummarizeComponent {

  hideLeftContent: boolean = true;
  summarizationDataList: any = [];
  showPaginateSpinner: boolean = false;
  constructor(
    private summarizeService: SummarizeService,
    private httpLoader: HttpLoader,
    private alert: AlertPopup
  ) {

  }

  ngOnInit() {
    this.getBotHistory();
  }


  summaryResponse(event: any) {
    let user_id = window.localStorage.getItem('user_id');
    let botPayload = {
      "user_id": user_id,
      "question": "summarization",
      "answer": event,
      "question_type": "summary",
      "bot_type": "bot",
      "sequence_id": new Date().valueOf()
    };
    this.summarizeService.createHistory(botPayload).subscribe((result: any) => {
      if (result['success']) {
        let data: any = {};
        data["question_type"] = "history";
        data["bot_answer"] = botPayload['answer'];
        data["sequence_id"] = result['createdMessage']["sequence_id"];
        data["history_id"] = result['createdMessage']["history_id"];
        data["created_at"] = new Date();

        this.summarizationDataList.unshift(data);
      }
    });

  }

  expandedSummaryIndexes = new Set<number>();

  // =====================================================
  // TOGGLE SUMMARY
  // =====================================================

  toggleSummary(index: number): void {
    if (this.expandedSummaryIndexes.has(index)) {
      this.expandedSummaryIndexes.delete(index);
    } else {
      this.expandedSummaryIndexes.add(index);
    }
  }


  // =====================================================
  // CHECK SUMMARY EXPANDED
  // =====================================================

  isSummaryExpanded(index: number): boolean {
    return this.expandedSummaryIndexes.has(index);
  }


  // =====================================================
  // EXPAND ALL
  // =====================================================

  expandAll(): void {
    this.expandedSummaryIndexes = new Set(
      this.summarizationDataList.map((_: any, index: any) => index)
    );
  }

  isLeftPanelCollapsed = false;

  toggleLeftPanel(): void {
    this.isLeftPanelCollapsed = !this.isLeftPanelCollapsed;
  }

  // =====================================================
  // COLLAPSE ALL
  // =====================================================

  collapseAll(): void {
    this.expandedSummaryIndexes.clear();
  }


  getBotHistory(): void {
    this.showPaginateSpinner = true;
    this.httpLoader.showLoader();

    this.summarizeService.getChatBotHistory()
      .pipe(
        finalize(() => {
          this.showPaginateSpinner = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (result: any) => {
          if (result?.success) {
            const data = Array.isArray(result.result)
              ? result.result
              : [];

            this.summarizationDataList = data.filter(
              (item: any) => item?.question_type === 'summary'
            );
          } else {
            this.summarizationDataList = [];

            console.warn(
              'Failed to retrieve chatbot history:',
              result?.message || 'Unknown error'
            );
          }
        },
        error: (error: HttpErrorResponse) => {
          this.summarizationDataList = [];

          console.error(
            'Error retrieving chatbot history:',
            error.message
          );
        }
      });
  }

}
